export const SearchIcon = ({ width, height, color }) => (
  <svg
    height="20"
    width="20"
    viewBox="0 0 20 20"
    fill={color || '#999999'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="search_black_24dp (2)">
      <path
        id="Path 45"
        d="M12.9167 11.6667H12.2583L12.025 11.4417C12.9388 10.377 13.4046 8.99969 13.3246 7.59891C13.2445 6.19813 12.6249 4.88284 11.5957 3.92918C10.5666 2.97553 9.208 2.45769 7.80519 2.48438C6.40237 2.51108 5.06446 3.08023 4.07235 4.07235C3.08023 5.06446 2.51108 6.40237 2.48438 7.80519C2.45769 9.208 2.97553 10.5666 3.92918 11.5957C4.88284 12.6249 6.19813 13.2445 7.59891 13.3246C8.99969 13.4046 10.377 12.9388 11.4417 12.025L11.6667 12.2583V12.9167L15.8333 17.075L17.075 15.8333L12.9167 11.6667ZM7.91668 11.6667C7.175 11.6667 6.44998 11.4467 5.83329 11.0347C5.21661 10.6226 4.73596 10.037 4.45213 9.35175C4.16831 8.66652 4.09404 7.91252 4.23874 7.18509C4.38343 6.45766 4.74059 5.78948 5.26503 5.26503C5.78948 4.74059 6.45766 4.38343 7.18509 4.23874C7.91252 4.09404 8.66652 4.16831 9.35175 4.45213C10.037 4.73596 10.6226 5.21661 11.0347 5.83329C11.4467 6.44998 11.6667 7.175 11.6667 7.91668C11.6673 8.40932 11.5708 8.89726 11.3826 9.35252C11.1943 9.80779 10.9182 10.2214 10.5698 10.5698C10.2214 10.9182 9.80779 11.1943 9.35252 11.3826C8.89726 11.5708 8.40932 11.6673 7.91668 11.6667Z"
        fill={color || '#999999'}
      />
    </g>
  </svg>
)
export const CrossIcon = ({ width = '8', height = '8', color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 234">
      <path id="Vector 9" d="M1 7L7 1" stroke="#999999" />
      <path id="Vector 10" d="M7 7L1 1" stroke="#999999" />
    </g>
  </svg>
)
export const DownIcon = ({ width, height, color }) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path id="Vector 7" d="M1 1L5 5L9 1" stroke="#5574C9" strokeWidth="1.5" />
  </svg>
)
